export const footerHeight = 92;

const styles = (theme) => ({
  footerContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    borderTop: '1px solid #D9DCDF',
    background: '#fff',
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    height: footerHeight,
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  footerContent: {
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    margin: '0 auto'
  }
});

export default styles;